// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-container {\n  background: white;\n}\n.nav-container .bottom-line {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: #ccd5d4;\n  height: 1px;\n  width: 100%;\n}\n.nav-bar-icon {\n  width: 20px;\n  opacity: 0.7;\n  transition: var(--d-ease);\n}\n.nav-bar-icon:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
